export const ACTION_NAME_TO_DISPLAY = {
  CREATE: 'create',
  READ: 'view',
  UPDATE: 'edit',
  DELETE: 'delete',
  ALLOW: 'view',
};

export const FIELDS_ACTIONS = [
  {
    label: 'View/Edit',
    permissions: [
      { name: 'READ', subtype: 'ALL' },
      { name: 'UPDATE', subtype: 'ALL' },
    ],
    tooltip: 'Users will have permission to view and edit this field.',
  },
  {
    label: 'View/Owner Edit',
    permissions: [
      { name: 'READ', subtype: 'ALL' },
      { name: 'UPDATE', subtype: 'OWNER' },
    ],
    tooltip: `User be granted permission to edit this field only if they are the resource's assigned user.
    Otherwise, they can only view the field.`,
  },
  {
    label: 'View Only',
    permissions: [
      { name: 'READ', subtype: 'ALL' },
      { name: 'UPDATE', subtype: 'NONE' },
    ],
    tooltip: 'Users can view the data in this field, but cannot alter it.',
  },
  {
    label: 'Owner View/Owner Edit',
    permissions: [
      { name: 'READ', subtype: 'OWNER' },
      { name: 'UPDATE', subtype: 'OWNER' },
    ],
    tooltip:
      "Users will have permission to view and edit this field only if they are the resource's assigned user.",
  },
  {
    label: 'Disabled',
    permissions: [
      { name: 'READ', subtype: 'NONE' },
      { name: 'UPDATE', subtype: 'NONE' },
    ],
    tooltip: "This field will not be visible to the user's view.",
  },
];

export const LABELS_TO_TOOLTIP = {
  ALLOW: '',
  NONE: 'Nobody can perform the action',
  ALL: 'All users who are assigned to the role',
  OWNER: 'The user assigned to the resource',
};
